// src/components/FilterOptions.js
import React, { useState, useEffect, useRef } from 'react';
import { FaFilter } from 'react-icons/fa'; 
import './FilterOptions.css'; 

const FilterOptions = ({ filters, handleFilterChange, filterFields, handleCheckboxChange, selectedFields }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <aside className="filter-panel">
      <div className="filter-options-container" ref={dropdownRef}>
        <button className="btn btn-primary" onClick={toggleDropdown}>
        <FaFilter className="filter-icon" />
        </button>
        {isOpen && (
          <div className="dropdown-menu show">
            {filterFields.map((field) => (
              <div key={field} className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  value={field}
                  checked={selectedFields.includes(field)}
                  onChange={handleCheckboxChange}
                  id={`filter-checkbox-${field}`}
                />
                <label className="form-check-label" htmlFor={`filter-checkbox-${field}`}>
                  {field.charAt(0).toUpperCase() + field.slice(1)}
                </label>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="selected-filters-container ">
        {selectedFields.map((filterKey) => (
          <div key={filterKey} className="filter-group">
            <label>{filterKey}</label>
            <input
              type="text"
              name={filterKey}
              placeholder={`Search by ${filterKey}`}
              value={filters[filterKey] || ''}
              onChange={handleFilterChange}
            />
          </div>
        ))}
      </div>
    </aside>
  );
};

export default FilterOptions;
